<template lang="pug">
.searchPanel
  .loteSearch(v-if="showPesquisaLote && isBa && caixa === 'ASSINATURA_CONJUNTA'")
    div.row
      span(@click="exibirBuscaPorLote")
      a.busca Pesquisa por lote
      el-tooltip(
        effect='dark',
        placement="top-end"
      )
        i.el-icon-info.icon-info
        template(slot="content") Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
          a.btn-download(@click="baixarModelo") (Baixar modelo)
    div
      app-upload-area(
        id="lote",
        :target="'publico/upload'"
        :fileType="validExtensions"
        :onSuccess="onSuccess"
        :documento="file"
        :hasDownloadButton="false",
        v-model="file"
        @removerDocumento="removerDocumento"
      )
      .right-buttons
        el-button.no-padding(
        v-if="showPesquisaLote"
        type="text",
        @click="voltar"
      ) Voltar
      el-row.button-row
        el-button(type="primary", @click="consultar")
          i.icon(class="fa fa-search")
          | Pesquisar
  .simpleSearch(v-if="filtro.simples && !showPesquisaLote", key="simpleSearch")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      el-input.input(
        :placeholder="placeholder",
        v-model="filtro.campoSimples",
        class="input-with-select"
      )
        el-button.color-default(
          slot="append",
          icon="el-icon-search",
          id='botao-filtro-simplificado'
          @click="pesquisar"
        )
  .advancedSearch(v-if="!filtro.simples && !showPesquisaLote")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      .panel
        el-row(:gutter="10")
          el-col(:lg="6", :md="12", :sm="24")
            p.titulo Processo:
            el-input(
              v-model="filtro.numeroProcesso",
              v-mask="['#########/####']"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
            p.titulo Período de Solicitação:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.periodoSolicitacao"
              name='data',
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroDataChegada")
            p.titulo Período de Chegada:
            el-date-picker.full-width.input.date(
              type="daterange",
              start-placeholder="Período Inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.dataChegadaSetor",
              @change="formatarDatas"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroResponsavel')")
            p.titulo Responsável:
            el-select.full-width(
              v-model='filtro.responsavel',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Responsável não encontrado",
              @clear="filtro.responsavel = null"
            )
              el-option(
                v-for='responsavel in responsaveis',
                :key='responsavel.id',
                :label='responsavel.nomeCargo',
                :value='responsavel.id'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroBairro')")
            p.titulo Bairro:
            el-input(
              v-model="filtro.bairro"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciado')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='`${credenciado.codigo} - ${credenciado.nome}`',
                :label='credenciado.nome',
                :value='credenciado.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciadoVistoria')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='credenciado',
                :label='credenciado',
                :value='credenciado'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciadoGeo')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='`${credenciado.codigo} - ${credenciado.nome}`',
                :label='credenciado.nome',
                :value='credenciado.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroVistoriador')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.tipoCredenciado',
              placeholder='Selecione',
              clearable,
              @clear="filtro.tipoCredenciado = null"
            )
              el-option(
                v-for='tipo in tipoCredenciado',
                :key='tipo.codigo',
                :label='tipo.name',
                :value='tipo.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoTituloCertidao')")
            p.titulo Situação:
            el-select.full-width(
              v-model='filtro.status',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='situacao in situacaoTituloCertidao',
                :key='situacao.codigo',
                :label='situacao.nome',
                :value='situacao.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOS')")
            p.titulo Ordem de Serviço:
            el-select.full-width(
              v-model='filtro.numeroOs',
              placeholder='Selecione',
              clearable,
              filterable
            )
              el-option(
                v-for='ordemServico in ordemServicoList',
                :key='ordemServico.id',
                :label='ordemServico.label',
                :value='ordemServico.label'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOrdemServico')")
            p.titulo Ordem de Serviço:
            el-input(
              v-model="filtro.numeroOs"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroFuncao')")
            p.titulo Função:
            el-select.full-width(
              v-model='filtro.funcao',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='funcao in funcoes',
                :key='funcao.codigo',
                :label='funcao.nome',
                :value='funcao.codigo'
              )
          div
            el-col(:lg="6", :md="12", :sm="24", v-if="(showFiltro('filtroCpf') && !showfiltrosInformacoes && !showFiltroPublicacaoPortaria && !showFiltroPublicacao)")
              p.titulo CPF/CNPJ do Interessado:
              el-input.input(
                v-model="filtro.cpfCnpjInteressado",
                class="input-with-select",
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Setor de Origem:
              el-select.full-width(
                v-model='filtro.setorOrigem',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='setor in setores'
                  :key='setor.id'
                  :label='setor.nome',
                  :value='setor.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroSetor")
              p.titulo Setor:
              el-select.full-width(
                v-model='filtro.setor',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='setor in setores'
                  :key='setor.id'
                  :label='setor.nome',
                  :value='setor.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoTituloCertidao') && !isMa")
              p.titulo Setor:
              el-select.full-width(
                v-model='filtro.setorProcesso',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='(codigo, setor) in setoresTituloCertidao'
                  :key='setor'
                  :label='codigo'
                  :value='setor'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="!showfiltrosInformacoes")
              p.titulo Nome/Razão Social do Interessado:
              el-input(
                v-model="filtro.nomeInteressado"
              )
            el-col(:lg="6", :md="12", :sm="24" v-if="showFiltro('filtroClausulaResolutiva')")
              p.titulo Situação cláusula resolutiva:
              el-select.full-width(
                v-model='filtro.situacaoClausulaResolutiva',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='tipo in situacaoClausulaResolutiva',
                  :key='tipo.codigo',
                  :label='tipo.nome',
                  :value='tipo.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
                p.titulo Número portaria:
                el-input(
                  v-model="filtro.numeroPortaria"
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
              p.titulo Número publicação de portaria:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacao")
              p.titulo Número publicação:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Denominação do imóvel:
              el-input(
                v-model="filtro.denominacao",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Período de publicação:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.periodoPublicacao"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Tipo de processo:
              div(v-if="showFiltroTipoMultiplo")
                el-select.full-width(
                  v-model='filtro.tipos',
                  placeholder='Selecione',
                  multiple,
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
              div(v-else)
                el-select.full-width(
                  v-model='filtro.tipo',
                  placeholder='Selecione',
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacaoBoleto') || isCof")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTipoPagamento') || showFiltroTipoPagamentoCOF")
              p.titulo Tipo de Pagamento:
              el-select.full-width(
                v-model='filtro.tipoPagamentoVtn',
                placeholder='Selecione',
                clearable
              )
                el-option(key='A_VISTA', label='À vista', value='A_VISTA')
                el-option(key='PARCELADO', label='À prazo', value='PARCELADO')
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacao') && !showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoes',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24" v-if="!(isBa && (caixa === 'ASSINATURAS') || (caixa === 'EM_ANALISE_OS'))")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroPerfil')")
              p.titulo Perfil:
              el-select.full-width(
                v-model='filtro.perfilProcesso',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='perfil in perfisDJ',
                  :key='perfil.codigo',
                  :label='perfil.nome',
                  :value='perfil.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCadastrante')")
              p.titulo Executor:
              el-input(
                v-model="filtro.nomeCadastrante"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Status:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusSolicitacao',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )

          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroDataEmissaoTitulo")
            p.titulo Data de emissão do título:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.dataEmissaoTitulo"
              name='data',
            )

          el-col(:lg="6", :md="12", v-if="showFiltro('filtroSituacaoAssinatura')")
            p.titulo Situação:
            el-select.full-width(
              v-model='filtro.status',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='situacao in situacaoAssinaturaGabBA',
                :key='situacao.codigo',
                :label='situacao.nome',
                :value='situacao.codigo'
              )

          div(v-if="listaProcessosSelecionados")
            el-col.column-checkbox(:lg="6", :md="12", :sm="24" v-if="(!showFiltroPublicacaoPortaria && !showFiltroPublicacao)")
              el-checkbox(
                v-model="exibirProcessosSelecionados"
                @change="setCheckboxProcessosSelecionados()"
              )
                label.titulo Exibir apenas selecionados
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroStatusOrdemServico')")
              p.titulo Status da Ordem de Serviço:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusOs',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTitulo')")
              p.titulo Título/Certidão:
              el-input(
                v-model="filtro.numeroTitulo"
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroMunicipio')")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroReceita')")
              p.titulo Receita:
              el-select.full-width(
                v-model='filtro.receita',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='receita in receitas',
                  :key='receita.codigo',
                  :label='receita.descricao',
                  :value='receita.id'
                )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacao') && showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCPAV',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )

            el-col(:lg="6", :md="12", v-if="showFiltro('filtroSituacaoCertidao')")
              p.titulo Situação Certidão:
              el-select.full-width(
                v-model='filtro.situacaoCertidao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCertidao',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroDataVencimento')")
              p.titulo Data de Vencimento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataVencimento"
                name='data',
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroArquivadosGac')")
              p.titulo Data de Arquivamento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataArquivamento"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoBoleto')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRua')")
              p.titulo Rua:
              el-input(
                v-model="filtro.rua"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroBairro')")
              p.titulo Bairro:
              el-input(
                v-model="filtro.bairro"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRemessa')")
              p.titulo Remessa:
              el-input(
                v-model="filtro.remessa"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroQuadra')")
              p.titulo Quadra:
              el-input(
                v-model="filtro.quadra"
              )
          <button v-if="isMa" type="submit" style="display: none;"></button>

  .button-group
    .left-buttons
      el-button.no-padding(
        v-if="showPesquisaAvancadaFiltro"
        type="text",
        @click="changePesquisa"
      ) {{ tituloPesquisa }}
      el-button.no-padding(
        v-if="showButtonPesquisaLote && !showPesquisaLote && isBa && caixa === 'ASSINATURA_CONJUNTA'"
        type="text",
        @click="exibirBuscaPorLote"
      ) Pesquisa Lote
      el-button.no-padding(
        v-if="!showPesquisaLote"
        type="text",
        @click="limpar"
      ) Limpar
    .right-buttons
      el-button.btn(
        v-if="!filtro.simples && !showPesquisaLote",
        type="primary",
        id='botao-filtro-avancado'
        @click="pesquisar"
      )
        i.el-icon-search
        | &nbsp Pesquisar
</template>

<script>
import axios from '@/utils/api'
import FILTRO_EMPTY from '@/models/filtro'
import AppUploadArea from '@/components/AppUploadArea'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions, mapGetters } from 'vuex'
import { funcoes, perfisDJ, tiposNaoOnerosoGroup, tiposPeasGroup, statusOs, situacaoBoleto, situacoesCertidao, statusSolicitacao, situacaoTituloCertidao, situacoesArquivados, situacaoClausulaResolutiva, situacoesCPAV, situacaoTituloCertidaoMa, situacaoTituloCertidaoBa, situacaoBA, situacaoAssinaturaGabBA, situacaoTituloCertidaoAp } from '@/constants/selects'
import PermissaoHelper from '@/screens/analise/PermissaoHelper'
const { filtro, getOpcoesCredenciadoByPerfil } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { tiposProcessos } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const { setoresTituloCertidao, setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    AppUploadArea
  },

  mixins: [
    PermissaoHelper,
    AppNotificacao
  ],

  props: {
    showPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    showFiltroDataEmissaoTitulo: {
      type: Boolean,
      default: false
    },
    showButtonPesquisaLote: {
      type: Boolean,
      default: true
    },
    configuracaoFiltro: {
      type: Object,
      required: true
    },
    configuracaoFiltroSituacao: {
      type: Object,
      required: false
    },
    showFiltroTipoPagamentoCOF: {
      type: Boolean,
      default: false
    },
    isCof: {
      type: Boolean,
      default: false
    },
    showfiltrosInformacoes: {
      type: Boolean,
      default: false
    },
    showFiltroSetor: {
      type: Boolean,
      default: false
    },
    showFiltroDataChegada: {
      type: Boolean,
      default: false
    },
    showFiltroSetoresTituloCertidao: {
      type: Boolean,
      default: false
    },
    listaProcessosSelecionados: {
      default: false
    },
    placeholder: {
      type: String,
      default: filtro.placeholder
    },
    filtroRapido: {
      type: Object,
      required: false
    },
    showFiltroPublicacaoPortaria: {
      type: Boolean,
      default: false
    },
    showFiltroPublicacao: {
      type: Boolean,
      default: false
    },
    showFiltroTipoMultiplo: {
      type: Boolean,
      default: false
    },
    showFiltroSituacao: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      funcoes,
      caixa: '',
      tiposNaoOnerosoGroup,
      perfisDJ,
      tiposPeasGroup,
      statusSolicitacao,
      statusOs,
      situacoesCPAV,
      situacaoAssinaturaGabBA,
      situacaoBoleto,
      situacoesCertidao,
      situacaoClausulaResolutiva,
      situacaoTituloCertidao: process.env.ESTADO === 'ma' ? situacaoTituloCertidaoMa : process.env.ESTADO === 'ba' ? situacaoTituloCertidaoBa : process.env.ESTADO === 'ap' ? situacaoTituloCertidaoAp : situacaoTituloCertidao,
      situacoes: [],
      setores: [],
      exibirProcessosSelecionados: false,
      municipios: [],
      situacoesArquivados,
      filtro: FILTRO_EMPTY(),
      setoresTituloCertidao: setoresTituloCertidao,
      credenciados: null,
      tipoCredenciado: [],
      isBa: process.env.ESTADO === 'ba',
      isMa: process.env.ESTADO === 'ma',
      isPa: process.env.ESTADO === 'pa',
      ordemServicoList: [],
      showPesquisaLote: false,
      validExtensions: ['xlsx', 'xls', 'csv'],
      file: null,
      loadingTable: true,
      showPesquisaAvancadaFiltro: this.showPesquisaAvancada,
      filtroSearch: {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        setoresAtuais: [],
        setoresPassados: [],
        responsaveisAtuais: [],
        tipoPesquisa: 'SIMPLIFICADO',
        ordem: 'numeroProcesso',
        numeroProcesso: null,
        numeroComprovante: null,
        nomePlanilha: null,
        statusAmbiental: null,
        statusBloqueioDinamico: null
      },
      isAp: process.env.ESTADO === 'ap'
    }
  },

  async mounted () {
    if (this.isMa) {
      this.tipoCredenciado = getOpcoesCredenciadoByPerfil(this.usuario.perfilSelecionado.codigo)
    }
    this.municipios = await this.findMunicipiosByEstadoAtual()
    this.caixa = this.$route.name
    if (this.configuracaoFiltro?.filtroCredenciado &&
      this.configuracaoFiltro?.filtroCredenciado.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      let credenciadosVistoria = await this.findAllCredenciadoVistoria()
      credenciadosVistoria = credenciadosVistoria.map(c => ({codigo: c, nome: c}))
      let credenciadosGeo = await this.findAllCredenciadoGeo()
      let allCredenciados = credenciadosVistoria.concat(credenciadosGeo).sort((a, b) => a.nome.localeCompare(b.nome))
      const credenciadosUnicos = new Set()
      this.credenciados = allCredenciados.filter(({ nome }) => !credenciadosUnicos.has(nome) && credenciadosUnicos.add(nome))
    } else if (this.configuracaoFiltro?.filtroCredenciadoVistoria &&
      this.configuracaoFiltro?.filtroCredenciadoVistoria.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      this.credenciados = await this.findAllCredenciadoVistoria()
    } else if (this.configuracaoFiltro?.filtroCredenciadoGeo &&
      this.configuracaoFiltro?.filtroCredenciadoGeo.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      this.credenciados = await this.findAllCredenciadoGeo()
    }
    if (this.caixa && (this.caixa !== 'portariaHomologacao' && this.caixa !== 'publicacao' && !this.caixa.includes('vistoria-remota') && this.caixa !== 'CAIXA_SOLICITAÇÕES')) {
      this.responsaveis = await this.getUsuariosPorSetor(this.caixa)
      if (this.showfiltrosInformacoes || this.showFiltroSetor) {
        this.setores = await axios({
          method: 'GET',
          url: `solicitarInformacao/setores`,
          error: true
        })
        this.setores = this.setores.map(s => ({ ...s, nome: setoresFormatado[s.codigo] }))
      }
      const caixa = this.caixa === 'cof/gestaoVtn' ? 'GESTAO_VTN' : (this.caixa === 'gat/informacoesSolicitadas' || this.caixa === 'cof/informacoesSolicitadas' ? 'INFORMACAO_SOLICITADA' : this.caixa)
      if (this.isBa) {
        this.situacoes = situacaoBA
      } else {
        // Buscando por nomes distintos, no caso de haver mais de um status para processos em retificação
        this.situacoes = [...new Map((await axios({
          method: 'GET',
          url: `processo/getSituacoesBycaixa/${caixa}`
        })).map(situacao => [situacao.nome, situacao])).values()]

        if (this.isAp) {
          this.situacoes = [{
            nome: 'Aguardando Informação',
            codigo: 'AGUARDANDO_INFORMACAO'
          }, ...this.situacoes]
        }
      }
    }
    if (this.configuracaoFiltro?.filtroVistoriador) {
      this.tipoCredenciado = getOpcoesCredenciadoByPerfil(this.usuario.perfilSelecionado.codigo)
    }
    if (this.isBa) {
      this.funcoes = this.funcoes.filter(f => ['GEOMENSOR', 'VISTORIADOR'].includes(f.codigo))
    }
    if (this.showFiltro('filtroOS')) {
      this.ordemServicoList = await axios({
        method: 'GET',
        url: 'ordemServico/select/getAll'
      })
    }
  },

  computed: {

    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    tituloPesquisa () {
      return this.filtro.simples ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },
    tiposCadastroSelect () {
      if (this.isMa && this.$route.name === 'PROCESSO_ARQUIVADO' && this.usuario.perfilSelecionado?.codigo.includes('COMISSAO_ILHA')) {
        return tiposProcessos.filter(tipo => tipo?.codigo === 'REURB_COLETIVO' || tipo?.codigo === 'REURB_INDIVIDUAL')
      }
      if (this.isPa && this.$route.fullPath === '/analise/RELATORIO_CREDENCIADOS') {
        return tiposProcessos.filter(tipo => tipo?.codigo === 'ONEROSO' || tipo?.codigo === 'NAO_ONEROSO' || tipo?.codigo === 'CERTIDAO_TITULO')
      }
      return tiposProcessos
    }
  },

  methods: {
    ...mapActions({
      getUsuariosPorSetor: 'dados/getUsuariosPorSetor',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      findAllCredenciadoVistoria: 'pessoa/findAllCredenciadoVistoria',
      findAllCredenciadoGeo: 'pessoa/findAllCredenciadoGeo',
      findProcessosByFilter: 'dashboardRelatorios/findProcessosByFilter',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'

    }),

    showFiltro (campo) {
      if (!this.usuario) {
        return false
      }
      return this.configuracaoFiltro[campo] && this.configuracaoFiltro[campo].find((perfil) => perfil === this.usuario?.perfilSelecionado.codigo)
    },

    limpar () {
      this.filtro = { ...FILTRO_EMPTY(), simples: this.filtro.simples }
      this.exibirProcessosSelecionados = false
      this.$emit('limpar')
    },

    baixarModelo () {
      this.getModeloRelatorio()
    },

    changePesquisa () {
      this.filtro.simples = !this.filtro.simples
      this.filtro.campoSimples = ''
      this.filtro.cpfCnpjInteressado = ''
      this.filtro.nomeInteressado = ''
      this.filtro.numeroProcesso = ''
      this.filtro.municipio = []
      this.filtro.funcao = ''
      this.filtro.setorOrigem = ''
      this.filtro.tipo = ''
      this.filtro.dataVencimento = null
      this.filtro.dataArquivamento = null
      this.filtro.situacao = ''
      this.filtro.status = ''
      this.filtro.statusSolicitacao = ''
      this.filtro.statusOs = ''
      this.filtro.situacaoCertidao = ''
      this.filtro.tipoPagamentoVtn = ''
      this.filtro.situacaoClausulaResolutiva = ''
      this.filtro.ordem = ''
      this.filtro.receita = ''
      this.filtro.responsavel = ''
      this.filtro.setorOrigem = ''
    },

    pesquisar () {
      if (this.filtroRapido) {
        this.filtro = {
          ...this.filtro,
          ...this.filtroRapido
        }
      }
      if (this.filtro.nomeInteressado) {
        this.filtro.nomeInteressado = this.filtro.nomeInteressado.trim()
      }
      this.$emit('pesquisar', this.filtro)
    },

    formatResponsavel (responsavel) {
      if (!this.showFuncaoResponsavel) {
        return responsavel.pessoa.pessoaFisica.nome
      }

      return `${responsavel.pessoa.pessoaFisica.nome} (${responsavel.perfis ? responsavel.perfis[0].nome : ''})`
    },

    setCheckboxProcessosSelecionados () {
      if (this.exibirProcessosSelecionados) {
        this.filtro.processos = this.listaProcessosSelecionados
      } else {
        this.filtro.processos = []
      }
    },

    formatarDatas () {
      if (this.filtro.dataChegadaSetor) {
        const inicio = new Date(this.filtro.dataChegadaSetor[0])
        const fim = new Date(this.filtro.dataChegadaSetor[1])

        inicio.setHours(0, 0, 0, 0)
        fim.setHours(23, 59, 59, 999)

        this.filtro.dataChegadaSetor = [inicio, fim]
      }
    },

    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
      this.filtro.simples = false
      this.showPesquisaAvancadaFiltro = !this.showPesquisaAvancadaFiltro
    },

    voltar () {
      this.filtro.simples = true
      this.showPesquisaAvancadaFiltro = true
      this.showPesquisaLote = false
      this.removerDocumento()
      this.limpar()
    },

    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filtroSearch.nomePlanilha = this.file.fileKey
    },

    removerDocumento () {
      this.file = null
      this.filtroSearch.nomePlanilha = null
    },
    async consultar () {
      this.loadingTable = true
      this.filtroSearch.simplificado = false
      this.filtroSearch.pagina = 0
      this.filtroSearch.setoresAtuais = [this.usuario.perfilSelecionado.setor.codigo]
      this.page = 1

      if (this.dataCadastro && this.dataCadastro.length > 1) {
        this.filtroSearch.dataInicio = this.dataCadastro[0]
        this.filtroSearch.dataFim = this.dataCadastro[1]
      } else {
        this.filtroSearch.dataInicio = null
        this.filtroSearch.dataFim = null
      }
      this.processos = await this.findProcessosByFilter({...this.filtroSearch})
      this.processos.content = this.processos.content.map(processo => ({
        ...processo,
        municipio: processo.municipioFormatado,
        tipo: processo.tipo.nome
      }))

      this.$emit('retornoPesquisaLote', this.processos)
      this.loadingTable = false
    }
  }
}
</script>

<style scoped lang="scss">

.button-row {
  margin-top: 10px;
  text-align: right;
}

.color-default {
  color: #009d64 !important;
  font-size: 16px;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn {
    padding: 8px;
  }
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.column-checkbox {
  padding-top: 20px;
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.titulo {
  margin: 0;
  padding: 12px 0 8px 0px;
}

.busca {
  padding: 0px 0 8px 0px;
  text-align: left;
  cursor: pointer;
  color: #009d64;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/Filtro.vue